import React from "react";
import { ICButton } from "../core-component/ui";
import UseTranslationHook from "../hooks/UseTranslationHook";
import { localStorageUtils } from "../utils/LocalStorageUtil";
import { useNavigate } from "react-router-dom";
import { routeAdmin, routeMaster } from "../routes/AuthRoutePath";
import { routePublic } from "../routes/PublicRoutePath";
import ICImage from "../core-component/ui/ICImage";

const PageNotFound = () => {
  const { t } = UseTranslationHook();
  const navigate = useNavigate();
  const storedAccessToken = localStorageUtils.getAccessToken();

  return (
    <div className="h-screen w-screen bg-subtle flex items-center justify-center">
      <div className="text-center px-4 md:px-8 max-w-lg mx-auto">
        <h1 className="text-6xl md:text-8xl">{t("404_error_code")}</h1>

        <ICImage
          className="mx-auto"
          src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
          alt="Page Not Found"
        />
        <div>
          <h3 className="text-2xl md:text-4xl font-bold mt-2">
            {t("404_error_message")}
          </h3>
          <p className="text-md md:text-lg mt-2 md:mt-4">
            {t("404_error_message_des")}
          </p>
          <ICButton
            type="button"
            className="!w-full mt-4 md:mt-6 py-2 px-4 sm:py-2 sm:px-6 md:py-3 md:px-8 bg-accent-emphasis text-on-accent rounded-lg"
            onClick={() => {
              storedAccessToken
                ? navigate("/" + routeMaster.admin + "/" + routeAdmin.lookup, {
                    replace: true,
                  })
                : navigate("/" + routePublic.login, { replace: true });
            }}
          >
            {t("go_to_home_button")}
          </ICButton>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
